/**
 * AdBugOfferCard is shown when the guest is on a PDP and that sku has an offer associated with it.
 *
 * @module views/components/AdBugOfferCard
 * @memberof -Common
 */
import './AdBugOfferCard.scss';

import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Text } from 'web-palette/dist/components/Text/Text';

import Link_Huge from '@ulta/core/components/Link_Huge/Link_Huge';
import UltaAsset from '@ulta/core/components/UltaAsset/UltaAsset';
import { spreadProps } from '@ulta/core/utils/dom/dom';

/**
 * Represents a AdBugOfferCard component
 *
 * @method
 * @param {AdBugOfferCard} props - React properties passed from composition
 * @returns AdBugOfferCard
 */
export const AdBugOfferCard = ( props ) => {

  const { image, title, description, expiryInfo, itemClickAction, backgroundColor } = props

  if( !image && !title && !description && !expiryInfo && !itemClickAction && !backgroundColor ){
    return null;
  }

  return (
    <div className={ classNames( 'AdBugOfferCard', {
      [`AdBugOfferCard--${backgroundColor}`]: backgroundColor
    } ) }
    role='group'
    aria-label='offer'
    >
      <Link_Huge action={ itemClickAction }>
        <div className='AdBugOfferCard__Content'>
          { image && <div className='AdBugOfferCard__Image'>
            <UltaAsset
              { ...spreadProps( { ...image } ) }
              altText=''
              height={ 56 }
              width={ 56 }
            />
          </div> }
          <div className='AdBugOfferCard__Text'>
            { title &&
              <Text
                htmlTag='h3'
                textAlign='left'
                textColor='default'
                textStyle='title-xs'
              >
                { title }
              </Text> }
            { description &&
              <Text
                htmlTag='p'
                textAlign='left'
                textColor='default'
                textStyle='body-sm'
              >
                { description }
              </Text> }
            { expiryInfo &&
              <Text
                htmlTag='p'
                textAlign='left'
                textColor='subtle'
                textStyle='body-sm'
              >
                { expiryInfo }
              </Text> }
          </div>
        </div>
      </Link_Huge>
    </div>
  )
}

/**
 * Property type definitions
 * @typedef AdBugOfferCard
 * @type {object}
 * @property {object} image - Sets the Header image
 * @property {string} title - Sets the title
 * @property {string} description - Sets the description
 * @property {string} expiryInfo - Sets the expiryInfo
 * @property {object} itemClickAction - Sets the actionGroup
 * @property {string} backgroundColor - Sets the background color
 */
export const propTypes = {
  image: PropTypes.object,
  title: PropTypes.string,
  description: PropTypes.string,
  expiryInfo: PropTypes.string,
  itemClickAction: PropTypes.object,
  backgroundColor: PropTypes.string
};

AdBugOfferCard.propTypes = propTypes;

export default AdBugOfferCard;